module.exports = __webpack_public_path__ + "static/media/post-challenge-lose-face.eaea2dca.svg";